import React from 'react';
import { Image, keyframes, usePrefersReducedMotion } from '@chakra-ui/react';
import logo from './lds.png';

export const Logo = props => {
  return <Image boxSize="200px" objectFit={'contain'} src={logo} {...props} />;
};
